export default "__VITE_PUBLIC_ASSET__06ffdb89__"